/* Interaktionen der Startseite.

   Ein Skript für alle Sections, aber jeder Teil prüft zuerst, ob es sein
   Markup überhaupt gibt — Sections lassen sich im Admin einzeln entfernen,
   und dann darf hier nichts brechen.

   Bewusst ohne Framework und ohne Custom Elements: Es geht um Umschalter,
   Filter und einen Dialog, nicht um Zustandsverwaltung. */

(function () {
  'use strict';

  /* Nur EINMAL laufen, egal wie oft die Datei eingebunden ist.

     Zehn Sections binden dieses Skript ein, weil jede für sich funktionieren
     muss. Der Browser lädt die Datei dann zwar nur einmal, führt sie aber je
     `<script src>` einmal AUS — auf der Startseite standen zuletzt acht
     Einbindungen, also acht Durchläufe und acht Zuhörer an jedem Knopf.

     Bei den meisten Umschaltern fällt das nicht auf; bei „Mehr lesen" schon:
     Der Knopf ruft `classList.toggle`, und acht Umschaltungen pro Klick heben
     sich gegenseitig auf. Der Text blieb zu, die Beschriftung blieb „Mehr
     lesen", und es sah aus, als sei der Knopf tot. Vorher waren es sieben
     Einbindungen — eine ungerade Zahl, die netto eine Umschaltung ergibt.
     Deshalb hat derselbe Knopf gestern noch funktioniert: Die neunte Section
     hat nichts kaputt gemacht, sondern eine bestehende Schwäche sichtbar.

     Gemessen am 11.8.2026: `DOMTokenList.prototype.toggle` wurde bei einem
     Klick achtmal aufgerufen, danach einmal. */
  if (window.__vantiqStartseiteLaeuft) return;
  window.__vantiqStartseiteLaeuft = true;

  var SPEICHER = 'vantiq-fahrzeug';
  /* Die für das gewählte Fahrzeug zugelassenen Grössen, als JSON-Liste
     („205/55R16"). Grundlage dafür, Listen auf das Fahrzeug einzugrenzen. */
  var GROESSEN = 'vantiq-fahrzeug-groessen';
  /* Das vollstaendige Fahrzeug samt Last- und Geschwindigkeitsindex je
     Groesse. Liegt getrennt, damit die zwei aelteren Schluessel ihr Format
     behalten — siehe die Begruendung in setzen(). */
  var DATEN = 'vantiq-fahrzeug-daten';

  function da(wahl, wurzel) {
    return (wurzel || document).querySelector(wahl);
  }

  function alle(wahl, wurzel) {
    return Array.prototype.slice.call((wurzel || document).querySelectorAll(wahl));
  }

  /* Es gibt keinen Liquid-Filter für den Schweizer Tausender-Apostroph;
     dieselbe Regel wie in snippets/tire-size-detail.liquid. */
  function chf(betrag) {
    var teile = betrag.toFixed(2).split('.');
    return teile[0].replace(/\B(?=(\d{3})+(?!\d))/g, '’') + '.' + teile[1];
  }

  function ohneDiakritika(text) {
    return text
      .toLowerCase()
      .replace(/ä/g, 'a')
      .replace(/ö/g, 'o')
      .replace(/ü/g, 'u')
      .replace(/ß/g, 'ss');
  }

  /* ---------------------------------------------------------- Saisonhinweis
     Der Hinweis kennt das Datum. Faustregel in der Schweiz: von O bis O,
     also Oktober bis Ostern. */
  /* Kalenderwoche nach ISO 8601 — dieselbe Zählung wie in den Nachfragedaten. */
  function kalenderwoche(d) {
    var t = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
    t.setUTCDate(t.getUTCDate() + 4 - (t.getUTCDay() || 7));
    var jahresanfang = new Date(Date.UTC(t.getUTCFullYear(), 0, 1));
    return Math.ceil(((t - jahresanfang) / 864e5 + 1) / 7);
  }

  /* Der Saisonhinweis folgt der gemessenen Nachfrage, nicht dem Kalender.

     Vorher zählte er bis zum 1. Oktober herunter und schaltete erst dann auf
     „Winterreifen-Saison". Google Trends über fünf Jahre (Schweiz) sagt etwas
     anderes:

       KW 34  Nachfrage beginnt zu steigen
       KW 36  halbe Spitze
       KW 40  Spitze
       KW 46  zweite Welle (erster Schnee)
       KW 48  fällt ab

     Der 1. Oktober liegt also GENAU AUF DER SPITZE — der Shop meldete die
     Saison, wenn sie schon lief. Und im April, wo Sommerreifen ihren
     Höhepunkt haben (KW 12–15), zählte er bereits zum Winter herunter.

     Jetzt nach Kalenderwoche, mit denselben Schwellen wie der Werbekalender.
  */
  function saisonhinweis() {
    var ziel = da('[data-rolle="saisonhinweis"]');
    if (!ziel) return;

    var heute = new Date();
    var kw = kalenderwoche(heute);
    var text;

    if (kw >= 8 && kw <= 17) {
      text = window.vantiqText('home.spring_change');
    } else if (kw >= 18 && kw <= 33) {
      /* Ruhige Zeit: Der Countdown liefe hier über drei Monate und wäre
         eher Lärm als Hinweis. */
      text = window.vantiqText('home.summer_season');
    } else if (kw >= 34 && kw <= 37) {
      var wochen = Math.max(38 - kw, 1);
      if (wochen === 1) {
        text = window.vantiqText('home.winter_countdown_one', { weeks: wochen });
      } else {
        text = window.vantiqText('home.winter_countdown_many', { weeks: wochen });
      }
    } else {
      text = window.vantiqText('home.winter_season');
    }

    ziel.innerHTML = text;
  }

  /* -------------------------------------------------------- Grössen-Decoder
     Die Texte stehen im Markup (data-Attribute der Knöpfe), damit sie im
     Admin pflegbar bleiben und im Quelltext stehen. */
  function decoder() {
    var teile = alle('.st-decoder__teil');
    if (!teile.length) return;

    var titel = da('[data-rolle="decoder-titel"]');
    var text = da('[data-rolle="decoder-text"]');
    var wert = da('[data-rolle="decoder-wert"]');
    var zusatz = da('[data-rolle="decoder-zusatz"]');

    function zeigen(knopf) {
      if (titel) titel.textContent = knopf.dataset.titel || '';
      if (text) text.textContent = knopf.dataset.text || '';
      if (wert) wert.textContent = knopf.dataset.wert || '';
      if (zusatz) zusatz.textContent = knopf.dataset.zusatz || '';

      teile.forEach(function (k) {
        k.setAttribute('aria-selected', String(k === knopf));
      });
      alle('.st-decoder__bild .masz').forEach(function (g) {
        g.classList.toggle('is-on', g.dataset.masz === knopf.dataset.teil);
      });
    }

    teile.forEach(function (knopf) {
      knopf.addEventListener('click', function () {
        zeigen(knopf);
      });
      knopf.addEventListener('mouseenter', function () {
        zeigen(knopf);
      });
      // Pfeiltasten wie in einer Reiterleiste
      knopf.addEventListener('keydown', function (e) {
        var i = teile.indexOf(knopf);
        if (e.key === 'ArrowRight' && i < teile.length - 1) {
          teile[i + 1].focus();
          zeigen(teile[i + 1]);
        }
        if (e.key === 'ArrowLeft' && i > 0) {
          teile[i - 1].focus();
          zeigen(teile[i - 1]);
        }
      });
    });
  }

  /* --------------------------------------------------------- Reifenkarten

     Mengenwahl, Merken und Kaufen hängen am document, nicht an der
     Produktreihe der Startseite: Dieselbe Karte steht auch in der Kollektion,
     und dort gibt es kein [data-rolle="produktreihe"]. Genau daran war das
     Herz auf der Kollektionsseite tot. */
  function karten() {
    /* Die gewählte Menge einer Karte. Sie steht nur im aria-pressed der
       Knöpfe — ein zweiter Speicher daneben würde auseinanderlaufen. */
    function mengeVon(karte) {
      var gewaehlt = da('[data-menge][aria-pressed="true"]', karte);
      return gewaehlt ? Number(gewaehlt.dataset.menge) : 1;
    }

    function kaufTextSetzen(karte, menge) {
      var text = da('[data-rolle="kaufen-text"]', karte);
      if (!text) return;
      /* Ohne Mengenwähler (Nicht-Reifen) bleibt die schlichte Beschriftung. */
      if (!da('[data-menge]', karte)) return;
      text.textContent = menge === 1
        ? window.vantiqText('home.add_one_tyre')
        : window.vantiqText('home.add_many_tyres', { count: menge });
    }

    document.addEventListener('click', function (e) {
      var mengeKnopf = e.target.closest('[data-menge]');
      if (mengeKnopf) {
        var karte = mengeKnopf.closest('.st-produkt');
        if (!karte) return;
        alle('[data-menge]', karte).forEach(function (b) {
          b.setAttribute('aria-pressed', 'false');
        });
        mengeKnopf.setAttribute('aria-pressed', 'true');

        var menge = Number(mengeKnopf.dataset.menge);
        var grund = Number(karte.dataset.grundpreis || 0);
        var satz = da('[data-rolle="satz"]', karte);
        if (satz && grund) {
          satz.textContent =
            menge === 1
              ? window.vantiqText('home.single_shipping')
              : window.vantiqText('home.quantity_price', {
                  count: menge,
                  price: 'CHF ' + chf(grund * menge),
                });
        }
        kaufTextSetzen(karte, menge);
        return;
      }

      var kaufen = e.target.closest('[data-rolle="kaufen"]');
      if (kaufen) {
        e.preventDefault();
        inDenKorb(kaufen);
        return;
      }

      var merken = e.target.closest('.st-produkt__merken');
      if (merken) {
        var an = merken.getAttribute('aria-pressed') === 'true';
        merken.setAttribute('aria-pressed', String(!an));
      }
    });
  }

  /* --------------------------------------------------------- Warenkorb

     Der Kaufknopf auf der Karte war bis hierher eine Attrappe: ein
     <button> ohne Handler. Wer darauf klickte, bekam nichts — und merkte es
     erst an der Kasse.

     Bewusst über /cart/add.js und nicht über ein Formular: Ein Formular
     lädt die Seite neu und wirft aus der Liste, in der gerade verglichen
     wird. Die Rückmeldung bleibt deshalb am Knopf. */
  function inDenKorb(knopf) {
    var karte = knopf.closest('.st-produkt');
    var variante = knopf.dataset.variante || (karte && karte.dataset.variante);
    if (!variante || knopf.disabled) return;

    var text = da('[data-rolle="kaufen-text"]', knopf) || knopf;
    var vorher = text.textContent;
    var gewaehlt = karte ? da('[data-menge][aria-pressed="true"]', karte) : null;
    var menge = gewaehlt ? Number(gewaehlt.dataset.menge) : 1;

    knopf.disabled = true;
    text.textContent = window.vantiqText('common.adding');

    fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variante), quantity: menge }] })
    })
      .then(function (antwort) {
        if (!antwort.ok) throw new Error('Warenkorb antwortete ' + antwort.status);
        return antwort.json();
      })
      .then(function () {
        knopf.classList.add('is-fertig');
        text.textContent = window.vantiqText('home.in_cart');
        korbGeaendertMelden();
        window.setTimeout(function () {
          knopf.classList.remove('is-fertig');
          knopf.disabled = false;
          text.textContent = vorher;
        }, 2200);
      })
      .catch(function (fehler) {
        /* Der häufigste Fall ist kein Netzfehler, sondern ein Standort, der
           für den Online-Shop nicht freigegeben ist — dann lehnt Shopify die
           Zeile ab. Der Knopf muss das sagen, nicht stumm zurückspringen. */
        console.warn('[VANTIQ] Warenkorb:', fehler);
        text.textContent = window.vantiqText('home.not_possible');
        window.setTimeout(function () {
          knopf.disabled = false;
          text.textContent = vorher;
        }, 2600);
      });
  }

  /* Zähler und Summe in der Kopfleiste nachziehen. Ohne das bleibt der Korb
     scheinbar leer, bis die nächste Seite geladen wird — und der Kauf wirkt,
     als wäre er nicht angekommen. */
  /* Der angedockte Warenkorb hoert darauf und holt sich neu — sonst zeigte er
     nach „In den Warenkorb" noch den Stand von vorher. */
  function korbGeaendertMelden() {
    document.dispatchEvent(new CustomEvent('vantiq:korb-geaendert'));
  }

  function korbZaehlerAktualisieren() {
    fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js', {
      headers: { Accept: 'application/json' }
    })
      .then(function (antwort) {
        return antwort.json();
      })
      .then(function (korb) {
        var zahl = da('[data-rolle="korb-zahl"]');
        if (zahl) zahl.textContent = String(korb.item_count);
        var summe = da('[data-rolle="korb-summe"]');
        if (summe) summe.textContent = 'CHF ' + chf(korb.total_price / 100);
      })
      .catch(function () {
        /* Der Artikel liegt trotzdem im Korb; ein falscher Zähler ist kein
           Grund, dem Kunden einen Fehler zu zeigen. */
      });
  }

  /* Alle Warenkorbwege melden dasselbe Ereignis: Reifenkarten, die
     Produktseite, Zusätze, der Warenkorb und die angedockte Spalte. So
     bleiben Anzahl und Betrag im eigenen VANTIQ-Kopf ohne Seitenwechsel
     synchron — Dawns cart-icon-bubble gehört nicht zu diesem Kopf. */
  document.addEventListener('vantiq:korb-geaendert', korbZaehlerAktualisieren);

  /* ------------------------------------------------------------- Produkte */
  function produkte() {
    var reihe = da('[data-rolle="produktreihe"]');
    if (!reihe) return;

    // Vergleichsschiene
    var schiene = da('[data-rolle="schiene"]');
    var zahl = da('[data-rolle="schiene-zahl"]');

    function schieneAktualisieren() {
      if (!schiene) return;
      var n = alle('[data-rolle="vergleich"]:checked', reihe).length;
      if (zahl) zahl.textContent = String(n);
      schiene.classList.toggle('is-an', n > 0);
    }

    reihe.addEventListener('change', function (e) {
      if (e.target.matches('[data-rolle="vergleich"]')) schieneAktualisieren();
    });

    var leeren = da('[data-rolle="schiene-leeren"]');
    if (leeren) {
      leeren.addEventListener('click', function () {
        alle('[data-rolle="vergleich"]', reihe).forEach(function (c) {
          c.checked = false;
        });
        schieneAktualisieren();
      });
    }

    // Saisonumschalter. Inaktive Gruppen liegen bis zur ersten Auswahl in
    // einem Template, damit die Startseite nicht zwoelf schwere Reifenkarten
    // gleichzeitig in den DOM einhaengt.
    alle('.st-saison-schalter button').forEach(function (knopf) {
      knopf.addEventListener('click', function () {
        var gruppe = alle('[data-saison-gruppe]', reihe).find(function (eintrag) {
          return eintrag.dataset.saisonGruppe === knopf.dataset.saison;
        });

        if (!gruppe) {
          var vorlage = alle('template[data-saison-vorlage]', reihe).find(function (eintrag) {
            return eintrag.dataset.saisonVorlage === knopf.dataset.saison;
          });
          if (vorlage) {
            vorlage.parentNode.insertBefore(vorlage.content.cloneNode(true), vorlage);
            gruppe = alle('[data-saison-gruppe]', reihe).find(function (eintrag) {
              return eintrag.dataset.saisonGruppe === knopf.dataset.saison;
            });
          }
        }

        if (!gruppe) return;

        alle('.st-saison-schalter button').forEach(function (b) {
          b.setAttribute('aria-pressed', 'false');
        });
        knopf.setAttribute('aria-pressed', 'true');
        alle('[data-saison-gruppe]', reihe).forEach(function (g) {
          g.hidden = g.dataset.saisonGruppe !== knopf.dataset.saison;
        });
        schieneAktualisieren();
        /* Der Fahrzeugfilter zählt nur die sichtbare Liste. Nach dem Tausch ist
           das eine andere, also muss er neu zählen — fahrzeug() ist eine eigene
           Closure und kommt an diese Stelle nur über ein Ereignis. */
        document.dispatchEvent(new CustomEvent('vantiq:liste-getauscht'));
      });
    });
  }

  /* --------------------------------------------------- Fahrzeuggedächtnis
     Das Fahrzeug bleibt im Browser, nicht auf dem Server — es ist eine
     Bequemlichkeit, keine Kundendatenhaltung. */
  function fahrzeug() {
    // Der Knopf steht mehrfach auf der Seite: in der Kategorienzeile und in
    // der Schublade für schmale Schirme.
    var waehlenAlle = alle('[data-rolle="fahrzeug-waehlen"]');
    var anzeigeAlle = alle('[data-rolle="fahrzeug-anzeige"]');
    var loeschenAlle = alle('[data-rolle="fahrzeug-loeschen"]');
    var dialog = da('[data-rolle="fahrzeug-dialog"]');

    var gewaehlt = null;
    var groessen = [];
    /* Die beiden abgeleiteten Formen. Sie werden aus dem vollständigen
       Fahrzeug berechnet, nicht gespeichert — sonst müssten drei Schlüssel
       zueinander passen, und beim ersten Formatwechsel liefen sie
       auseinander. Fehlt das vollständige Fahrzeug (Eintrag aus einem
       früheren Besuch), fallen beide auf den gespeicherten Text zurück. */
    var gewaehltBloss = null;
    var gewaehltLang = null;
    try {
      gewaehlt = window.localStorage.getItem(SPEICHER);
      groessen = JSON.parse(window.localStorage.getItem(GROESSEN) || '[]');
      var gespeichert = JSON.parse(window.localStorage.getItem(DATEN) || 'null');
      gewaehltBloss = blossname(gespeichert) || gewaehlt;
      gewaehltLang = langname(gespeichert) || gewaehlt;
    } catch (e) {
      gewaehlt = gewaehlt || null;
      groessen = [];
      gewaehltBloss = gewaehlt;
      gewaehltLang = gewaehlt;
    }
    if (!Array.isArray(groessen)) groessen = [];

    /*
      Listen auf die zugelassenen Grössen eingrenzen.

      Läuft im Browser, weil das Fahrzeug im Browser steht und nicht auf dem
      Server — die Seiten selbst sind für alle gleich und werden von Shopify
      zwischengespeichert.

      Karten ohne data-groesse bleiben immer stehen: Das sind Öle, Bürsten und
      alles, was keine Reifengrösse hat. Sie wegzufiltern hiesse, ein Fahrzeug
      als Aussage über Pflegemittel zu lesen.
    */
    function karteZeigen(karte) {
      var g = karte.dataset.groesse;
      /* Ohne Fahrzeug, ohne bekannte Grössen oder ohne Grösse an der Karte
         bleibt sie stehen. Letzteres betrifft Öle und Pflegemittel — ein
         Fahrzeug ist keine Aussage über Reifenglanz. */
      return !gewaehlt || !groessen.length || !g || groessen.indexOf(g) !== -1;
    }

    /* Eingegrenzt wird nur noch dort, wo der Hinweis das ausdrücklich verlangt
       — also in den kuratierten Reihen der Startseite.

       Auf Kollektions- und Suchseiten war das ein Fehler: Dort blendete diese
       Funktion die ganze Seite aus, weil unter den 24 geladenen Karten keine
       zugelassene Grösse war. Die Trefferzahl über der Liste stimmte weiter,
       die Blätterung meldete 1042 Seiten, und darunter stand nichts. Für die
       Kundin sah es aus, als hätte der Shop nichts für ihr Auto.

       Dort erledigt jetzt die Fahrzeugkarte die Arbeit: Sie führt mit echten
       Adressen auf gefilterte Listen, statt eine ungefilterte Liste im Browser
       leerzuräumen. */
    function listenFiltern() {
      alle('[data-rolle="fahrzeug-filter-hinweis"][data-eingrenzen]').forEach(function (hinweis) {
        alle('.st-produkt', hinweis.parentNode).forEach(function (karte) {
          karte.hidden = !karteZeigen(karte);
        });
      });

      /* Dann je Hinweis zählen. Bewusst über ALLE Listen im Elternknoten und
         nur über die sichtbaren: In tire-product-row liegt je Saison eine
         eigene <ul> im selben Elternknoten, von denen nur eine offen ist.
         Ein querySelector auf die erste Liste hätte dort die falsche gezählt. */
      alle('[data-rolle="fahrzeug-filter-hinweis"][data-eingrenzen]').forEach(function (hinweis) {
        var sichtbar = 0;
        var ausgeblendet = 0;

        alle('.st-produkte', hinweis.parentNode).forEach(function (liste) {
          if (liste.hidden) return;
          alle('.st-produkt', liste).forEach(function (karte) {
            if (karte.hidden) ausgeblendet += 1;
            else sichtbar += 1;
          });
        });

        hinweis.hidden = !gewaehlt || !ausgeblendet;

        var name = da('[data-rolle="filter-fahrzeug"]', hinweis);
        if (name && gewaehlt) name.textContent = gewaehlt;
        var zahl = da('[data-rolle="filter-zahl"]', hinweis);
        if (zahl) zahl.textContent = ausgeblendet;

        /* Bleibt nichts übrig, muss das dastehen. Ein leeres Raster unter einer
           gefüllten Überschrift liest sich als Fehler des Shops. */
        var leer = da('[data-rolle="filter-leer"]', hinweis);
        if (leer) leer.hidden = sichtbar > 0;
      });
    }

    function anwenden() {
      waehlenAlle.forEach(function (k) {
        k.hidden = Boolean(gewaehlt);
      });
      anzeigeAlle.forEach(function (anzeige) {
        anzeige.hidden = !gewaehlt;
        var name = da('[data-rolle="fahrzeug-name"]', anzeige);
        if (name && gewaehlt) {
          name.textContent = gewaehltLang || gewaehlt;
          /* Die Pille schneidet bei schmalem Schirm ab. Der volle Text
             gehört trotzdem greifbar — sonst weiss der Kunde nicht, ob der
             abgeschnittene Teil seine Motorisierung war. */
          name.title = gewaehltLang || gewaehlt;
        }
      });
      /* Die Zusage „Passt an Ihren …" gehört an die EINZELNE Karte und muss
         deren Grösse prüfen.

         Vorher stand sie auf jeder Karte, sobald überhaupt ein Fahrzeug
         gewählt war. Das fiel nicht auf, solange die unpassenden Karten
         ohnehin ausgeblendet wurden — als das Ausblenden auf den Listenseiten
         wegfiel, stand die Zusage plötzlich auf 285/30 R20 unter einem Auto,
         das 235er und 255er fährt. Eine falsche Zusage am Produkt ist
         schlimmer als gar keine.

         Karten ohne `data-groesse` (Öl, Pflegemittel) bekommen sie nie: Ein
         Fahrzeug ist keine Aussage über Reifenglanz. */
      alle('.st-produkt').forEach(function (karte) {
        var z = da('[data-rolle="passt"]', karte);
        if (!z) return;
        var g = karte.dataset.groesse;
        var passt = Boolean(gewaehlt) && groessen.length > 0 && Boolean(g) &&
                    groessen.indexOf(g) !== -1;
        z.hidden = !passt;
        if (passt) {
          var name = da('[data-rolle="passt-name"]', z);
          if (name) name.textContent = gewaehltBloss || gewaehlt;
        }
      });

      /* Zusagen ausserhalb einer Karte — etwa im Kopf einer Reihe — bleiben an
         der blossen Fahrzeugwahl hängen; dort gibt es keine Grösse zu prüfen. */
      alle('[data-rolle="passt"]').forEach(function (z) {
        if (z.closest('.st-produkt')) return;
        z.hidden = !gewaehlt;
        if (gewaehlt) {
          var t2 = da('[data-rolle="passt-name"]', z);
          if (t2) t2.textContent = gewaehltBloss || gewaehlt;
        }
      });

      /* Der Ausschnitt im Band „Warum VANTIQ" zeigt ein fremdes Auto, solange
         keines gewählt ist — und sagt das mit der Marke „Beispiel" daneben.
         Sobald eines im Speicher steht, gehört dort seins hin: Ein Beispiel
         neben der Zusage „wir zeigen nur, was an Ihr Auto darf" ist genau die
         Stelle, an der ein Kunde prüft, ob wir sein Auto überhaupt kennen.

         Die gespeicherte Grösse trägt Last- und Geschwindigkeitsindex mit
         (`255/40 R20 101 Y`) — gemessen, nicht angenommen: ein blosses
         Leerzeichen vor dem R einzusetzen ergab `255/40  R20 101 Y` mit
         doppeltem Abstand, und die drei Pillen brauchten drei Zeilen statt
         zwei. Hier zählt die blosse Grösse; die Indizes stehen auf der
         Fahrzeugkarte in der Filterspalte, wo sie gebraucht werden. */
      alle('[data-rolle="warum-fahrzeug"]').forEach(function (probe) {
        var name = da('[data-rolle="warum-fahrzeug-name"]', probe);
        var marke = da('[data-rolle="warum-beispiel"]', probe);
        var feld = da('[data-rolle="warum-fahrzeug-groessen"]', probe);
        if (marke) marke.hidden = Boolean(gewaehlt);
        if (!gewaehlt) return;
        if (name) name.textContent = gewaehltLang || gewaehlt;
        if (!feld || !groessen.length) return;
        feld.textContent = '';
        groessen.slice(0, 3).forEach(function (g) {
          var teile = String(g).match(/(\d{3})\s*\/\s*(\d{2})\s*R\s*(\d{2})/i);
          var pille = document.createElement('span');
          pille.className = 'st-warum__pille';
          pille.textContent = teile ? teile[1] + '/' + teile[2] + ' R' + teile[3] : String(g);
          feld.appendChild(pille);
        });
      });

      listenFiltern();
    }

    function setzen(wert, groessenListe, letztesFahrzeug) {
      gewaehlt = wert;
      gewaehltBloss = wert ? (blossname(letztesFahrzeug) || wert) : null;
      gewaehltLang = wert ? (langname(letztesFahrzeug) || wert) : null;
      groessen = wert && Array.isArray(groessenListe) ? groessenListe : [];
      try {
        if (wert) {
          window.localStorage.setItem(SPEICHER, wert);
          /* Die zugelassenen Grössen getrennt ablegen, nicht als JSON in
             denselben Schlüssel: Der Name wird an mehreren Stellen als reiner
             Text gelesen, und alte Einträge aus früheren Besuchen sind reine
             Zeichenketten. Ein Formatwechsel hätte sie unlesbar gemacht. */
          if (groessenListe && groessenListe.length) {
            window.localStorage.setItem(GROESSEN, JSON.stringify(groessenListe));
          } else {
            window.localStorage.removeItem(GROESSEN);
          }
          /* Zusätzlich das vollständige Fahrzeug ablegen — Motor, Baujahre und
             vor allem die Grössen MIT Last- und Geschwindigkeitsindex. Die
             Fahrzeugkarte über der Filterspalte braucht sie, um auszurechnen,
             wieviele Reifen wirklich passen; aus einer nackten Grössenliste
             lässt sich das nicht ableiten.

             Ein dritter Schlüssel und keine Erweiterung der beiden anderen:
             `vantiq-fahrzeug` wird an mehreren Stellen als reiner Text gelesen,
             und Einträge aus früheren Besuchen sollen lesbar bleiben. */
          if (letztesFahrzeug) {
            window.localStorage.setItem(DATEN, JSON.stringify(letztesFahrzeug));
          } else {
            window.localStorage.removeItem(DATEN);
          }
        } else {
          window.localStorage.removeItem(SPEICHER);
          window.localStorage.removeItem(GROESSEN);
          window.localStorage.removeItem(DATEN);
        }
      } catch (e) {
        /* privater Modus — dann gilt die Wahl nur für diesen Seitenaufruf */
      }
      anwenden();

      /* Der Wechsel muss die Seite erreichen. Die Fahrzeugkarte in der
         Filterspalte liest ihren Stand beim Laden aus dem Speicher — ohne
         dieses Ereignis zeigte sie nach einem Wechsel weiter das alte Auto,
         während im Kopf schon das neue stand. */
      document.dispatchEvent(new CustomEvent('vantiq:fahrzeug-geaendert', {
        detail: { name: wert, groessen: groessen, fahrzeug: letztesFahrzeug || null }
      }));
    }

    /* Kurzform für den Chip im Kopf: „BMW M2 3.0". Die volle Motorzeile
       „3.0 – 272 kW / 370 PS – N55B30A" hat dort keinen Platz. */
    /* Drei Formen desselben Fahrzeugs, je nachdem wo der Text steht.

         blossname  „VW Tiguan"
                    Mitten im Satz auf den Produktkacheln: „Passt an Ihren
                    VW Tiguan". Alles Weitere wäre dort ein Bandwurm, und die
                    Kachel sagt ohnehin schon, welche Grösse sie hat.

         kurzname   „VW Tiguan 2.0 l Benzin"
                    Was seit jeher unter `vantiq-fahrzeug` im Speicher liegt.
                    Bleibt unverändert, weil mehrere Bausteine diesen Schlüssel
                    als reinen Text lesen und Einträge aus früheren Besuchen
                    lesbar bleiben sollen.

         langname   „VW Tiguan CT · 2.0 l Benzin · 195 kW / 265 PS"
                    Steht allein in der grünen Pille und in der Fahrzeugkarte.
                    Dort ist Platz — und dort zählt der Unterschied: „VW Tiguan
                    2.0 l Benzin" trennt einen 150-PS- nicht von einem
                    265-PS-Motor, und die fahren verschiedene Reifen. */
    function blossname(f) {
      return (f && f.name) ? String(f.name) : '';
    }

    function kurzname(f) {
      if (!f || !f.name) return '';
      var m = motorteile(f);
      return m.beschreibung ? f.name + ' ' + m.beschreibung : f.name;
    }

    function langname(f) {
      if (!f || !f.name) return '';
      var m = motorteile(f);
      var stuecke = [f.name + (generation(f) ? ' ' + generation(f) : '')];
      if (m.beschreibung) stuecke.push(m.beschreibung);
      if (m.leistung) stuecke.push(m.leistung);
      return stuecke.join(' · ');
    }

    /* Die Generation gehört dazu — ein Tiguan I und ein Tiguan CT haben
       verschiedene Reifengrössen. Nur wenn sie wie eine Generation aussieht:
       Im Typ-Feld steht bei manchen Marken eine Motorvariante („164 Q.V.")
       oder ein Platzhalter, und beides gehört nicht in eine Pille. */
    function generation(f) {
      var t = String((f && f.typ) || '').trim();
      if (!t || t.length > 10) return '';
      if (/weitere|sonstige|unbekannt|nicht angegeben/i.test(t)) return '';

      /* Wortweise vergleichen, nicht als Zeichenkette.
         Die Version davor prüfte `name.indexOf(typ)`. Beim „VW Tiguan" mit Typ
         „I" traf das den Buchstaben in „Tiguan" — die Generation fiel weg,
         und ein Tiguan I sah aus wie ein Tiguan CT. Umgekehrt schrieb sie beim
         Alfa Romeo 164 mit Typ „164 Q.V." brav „164 164 Q.V.".
         Jetzt fallen genau die Wörter weg, die schon im Namen stehen. */
      var imNamen = String((f && f.name) || '').toLowerCase().split(/\s+/);
      var rest = t.split(/\s+/).filter(function (w) {
        return w && imNamen.indexOf(w.toLowerCase()) === -1;
      });
      return rest.join(' ');
    }

    /* Der Motortext kommt in mehreren Schreibweisen aus der Schnittstelle:

         „2.0 l Benzin – 195 kW / 265 PS – DKZ"
         „T+F – 1.4 TSI – 110 kW / 150 PS – BWK"      (mit Vorsatz)
         „Coupé S.Z. · 3.0 l Benzin – 152 kW / 207 PS – AR6150"

       Deshalb wird nicht auf Position zerlegt, sondern nach Inhalt gesucht:
       Der Abschnitt mit „kW" ist die Leistung, der davor die Beschreibung.
       Ein Zerlegen nach Position hätte beim Vorsatz „T+F" die falsche Hälfte
       genommen. */
    function motorteile(f) {
      var roh = String((f && f.motor) || '').trim();
      if (!roh) return { beschreibung: '', leistung: '' };
      var teile = roh.split(/[–—·]/).map(function (x) { return x.trim(); })
                     .filter(function (x) { return x; });
      var i = -1;
      for (var n = 0; n < teile.length; n++) {
        if (/\d\s*kW/i.test(teile[n])) { i = n; break; }
      }
      if (i === -1) return { beschreibung: teile[0] || '', leistung: '' };
      return { beschreibung: i > 0 ? teile[i - 1] : '', leistung: teile[i] };
    }

    /* Alle für das Fahrzeug zugelassenen Grössen, ohne Doppel. Bei
       Mischbereifung stehen Vorder- und Hinterachse getrennt darin — das ist
       gewollt, beide sind zugelassen, nur nicht rundum. */
    function groessenVon(f) {
      var liste = [];
      ((f && f.saetze) || []).forEach(function (satz) {
        (satz.achsen || []).forEach(function (achse) {
          if (achse.filter && liste.indexOf(achse.filter) === -1) {
            liste.push(achse.filter);
          }
        });
      });
      return liste;
    }

    document.addEventListener('vantiq:liste-getauscht', listenFiltern);

    /* „Alle passenden Reifen anzeigen" aus der Fahrzeugsuche: Fahrzeug
       übernehmen und hin. Das Speichern liegt hier, weil hier die einzige
       Stelle ist, die weiss, wie Name, Grössenliste und vollständige Daten
       zusammengehören — in der Suche noch einmal nachgebaut, liefen die drei
       Schlüssel früher oder später auseinander. */
    document.addEventListener('vantiq:fahrzeug-uebernehmen', function (e) {
      var f = e.detail && e.detail.fahrzeug;
      if (!f) return;
      setzen(kurzname(f), groessenVon(f), f);
      if (e.detail.ziel) window.location.href = e.detail.ziel;
    });

    waehlenAlle.forEach(function (knopf) {
      knopf.addEventListener('click', function () {
        /* Der Dialog wird nur mit der Bühne ausgeliefert. Auf allen anderen
           Seiten führt der Knopf zur Startseite statt ins Leere. */
        if (!dialog) {
          window.location.href = '/#suche';
          return;
        }
        dialog.showModal();
        /* Aufklappen per JS, damit das toggle-Ereignis feuert:
           tire-vehicle-search.js lädt die Markenliste erst dort. Steht das
           details von Anfang an offen, bleiben die Felder leer. */
        var stufen = da('[data-role="stepwise"]', dialog);
        if (stufen) stufen.open = true;
        var feld = da('[data-field="query"]', dialog);
        if (feld) feld.focus();
      });
    });

    if (dialog) {
      alle('[data-rolle="dlg-schliessen"]', dialog).forEach(function (knopf) {
        knopf.addEventListener('click', function () {
          dialog.close();
        });
      });

      var uebernehmen = da('[data-rolle="dlg-uebernehmen"]', dialog);
      if (uebernehmen) {
        /* Das Fahrzeug, das die Suche im Dialog gerade zeigt.

           Der Knopf gehört nicht zur Suchkomponente, sondern zum Dialogfuss —
           er kommt an die Auswahl nur über das Ereignis heran, das
           tire-vehicle-search.js aufsteigen lässt. Vorher schrieb er stur
           data-beispiel, und nach der Wahl eines BMW M2 stand im Kopf weiter
           der Demo-Golf. */
        var gezeigt = null;
        var kaskadeBereit = false;
        var suche = da('tire-vehicle-search', dialog);

        function knopfPruefen() {
          /* Übernehmen ist frei, sobald das Fahrzeug bestimmbar ist: entweder
             steht das Ergebnis schon da, oder die Auswahlfelder sind vollständig.

             Nur auf das Ergebnis zu warten war zu streng — wer Marke, Modell,
             Typ, Karosserie und Motor gewählt hat, hat sein Fahrzeug bestimmt
             und sollte nicht erst „Passende Reifengrössen anzeigen" klicken
             müssen, um es übernehmen zu dürfen. */
          uebernehmen.disabled = !gezeigt && !kaskadeBereit;
        }

        knopfPruefen();

        /* Beide Zustände kommen als Ereignis aus tire-vehicle-search.js. Am DOM
           abgelesen wären sie zeitweise veraltet — siehe knopfPruefen() dort. */
        dialog.addEventListener('fahrzeug:bereit', function (e) {
          kaskadeBereit = Boolean(e.detail && e.detail.bereit);
          knopfPruefen();
        });

        dialog.addEventListener('fahrzeug:gezeigt', function (e) {
          gezeigt = e.detail;
          knopfPruefen();
        });

        function uebernehmenAusfuehren() {
          if (!gezeigt) return false;
          setzen(kurzname(gezeigt), groessenVon(gezeigt), gezeigt);
          dialog.close();
          return true;
        }

        uebernehmen.addEventListener('click', function () {
          if (uebernehmenAusfuehren()) return;

          /* Noch kein Ergebnis geladen: Die Grössen holen wir selbst nach — sie
             sind der eigentliche Zweck der Übernahme, ohne sie kann keine Liste
             eingegrenzt werden. fahrzeugSuchen() löst ergebnisZeigen() aus und
             damit das Ereignis, das `gezeigt` füllt. */
          if (!suche || typeof suche.fahrzeugSuchen !== 'function') return;

          uebernehmen.disabled = true;
          Promise.resolve(suche.fahrzeugSuchen())
            .then(function () {
              /* Schlägt die Abfrage fehl, hat die Suche ihre eigene Meldung
                 gesetzt. Dann bleibt der Dialog offen und der Knopf wieder frei. */
              if (!uebernehmenAusfuehren()) knopfPruefen();
            })
            .catch(function () {
              knopfPruefen();
            });
        });
      }

      // Klick auf den Hintergrund schliesst ebenfalls
      dialog.addEventListener('click', function (e) {
        if (e.target === dialog) dialog.close();
      });
    }

    loeschenAlle.forEach(function (knopf) {
      knopf.addEventListener('click', function () {
        setzen(null);
      });
    });

    anwenden();
  }

  /* Das Kategorienmenü schliesst bei Klick daneben und mit Escape — sonst
     bleibt es offen stehen, sobald man woanders hinklickt. */
  function kopfmenue() {
    var menue = da('[data-rolle="kopfmenue"]');
    if (!menue) return;

    document.addEventListener('click', function (e) {
      if (menue.open && !menue.contains(e.target)) menue.open = false;
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && menue.open) menue.open = false;
    });
  }

  /* ------------------------------------------------------------------ FAQ */
  function faq() {
    var liste = da('[data-rolle="faq-liste"]');
    if (!liste) return;

    var fragen = alle('.st-faq__frage', liste);
    var suche = da('[data-rolle="faq-suche"]');
    var zaehler = da('[data-rolle="faq-zaehler"]');
    var leer = da('[data-rolle="faq-leer"]');
    var gruppe = 'alle';

    function filtern() {
      var wort = suche ? ohneDiakritika(suche.value.trim()) : '';
      var sichtbar = 0;

      fragen.forEach(function (frage) {
        var passtGruppe = gruppe === 'alle' || frage.dataset.gruppe === gruppe;
        var passtWort = wort === '' || ohneDiakritika(frage.textContent).indexOf(wort) !== -1;
        var zeigen = passtGruppe && passtWort;
        frage.hidden = !zeigen;
        if (zeigen) sichtbar++;
        // Wer sucht, will die Antwort sehen, nicht noch einmal klicken.
        if (zeigen && wort.length >= 3) frage.open = true;
      });

      if (leer) leer.hidden = sichtbar > 0;
      if (zaehler) {
        zaehler.textContent =
          sichtbar === fragen.length
            ? window.vantiqText('home.questions_all', { count: fragen.length })
            : window.vantiqText('home.questions_filtered', {
                visible: sichtbar,
                total: fragen.length,
              });
      }
    }

    if (suche) suche.addEventListener('input', filtern);

    alle('.st-faq__filter button').forEach(function (knopf) {
      knopf.addEventListener('click', function () {
        alle('.st-faq__filter button').forEach(function (b) {
          b.setAttribute('aria-pressed', 'false');
        });
        knopf.setAttribute('aria-pressed', 'true');
        gruppe = knopf.dataset.gruppe;
        filtern();
      });
    });

    var zurueck = da('[data-rolle="faq-zuruecksetzen"]');
    if (zurueck) {
      zurueck.addEventListener('click', function () {
        if (suche) suche.value = '';
        gruppe = 'alle';
        alle('.st-faq__filter button').forEach(function (b) {
          b.setAttribute('aria-pressed', String(b.dataset.gruppe === 'alle'));
        });
        filtern();
      });
    }

    /* Jede Frage hat eine eigene Adresse — teilbar, verlinkbar, und der
       Sprung aus einer Suchmaschine landet auf der offenen Antwort. */
    if (window.location.hash) {
      var ziel = document.getElementById(window.location.hash.slice(1));
      if (ziel && ziel.classList.contains('st-faq__frage')) {
        ziel.open = true;
        ziel.scrollIntoView();
      }
    }

    filtern();
  }

  /* ------------------------------------------------------------ Mehr lesen */
  function mehrlesen() {
    var knopf = da('[data-rolle="mehrlesen"]');
    var huelle = da('[data-rolle="seotext"]');
    if (!knopf || !huelle) return;

    knopf.addEventListener('click', function () {
      var offen = huelle.classList.toggle('is-offen');
      knopf.setAttribute('aria-expanded', String(offen));
      var text = da('[data-rolle="mehrlesen-text"]', knopf);
      if (text) text.textContent = offen
        ? window.vantiqText('home.less')
        : window.vantiqText('common.read_more');
    });
  }

  /* --------------------------------------------------------- Markenlogos
     Fehlt eine Logodatei, wird das Bild entfernt und die Wortmarke rückt
     gross nach — die Reihe sieht nie kaputt aus. */
  function markenlogos() {
    alle('[data-rolle="marken"] img').forEach(function (bild) {
      function weg() {
        var karte = bild.closest('a');
        if (karte) karte.classList.remove('hat-logo');
        bild.remove();
      }
      bild.addEventListener('error', weg);
      if (bild.complete && bild.naturalWidth === 0) weg();
    });
  }

  function start() {
    saisonhinweis();
    decoder();
    karten();
    produkte();
    fahrzeug();
    faq();
    mehrlesen();
    markenlogos();
    kopfmenue();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

/* Lupe im Kopf: Suchfeld auf dem Telefon auf- und zuklappen. */
(function () {
  'use strict';
  if (window.__vantiqKopflupe) return;
  window.__vantiqKopflupe = true;

  document.addEventListener('click', function (e) {
    var knopf = e.target.closest && e.target.closest('[data-rolle="suche-schalter"]');
    if (!knopf) return;
    var kopf = knopf.closest('.kopf');
    if (!kopf) return;
    var offen = kopf.classList.toggle('ist-suche-offen');
    knopf.setAttribute('aria-expanded', String(offen));
    if (offen) {
      var feld = kopf.querySelector('.kopf__suche input[type="search"], .kopf__suche input');
      if (feld) feld.focus();
    }
  });
})();
